export default "__VITE_ASSET__HvERlIKB__"